import Logger from '../Log'
import StartEventHook from './StartEventHook'

const Log = Logger.for('ConfigEnhanceHook')

export default class ConfigEnhanceHook extends StartEventHook {
  constructor () {
    super('ConfigEnhanceHook')
  }

  async run (remoteConfig) {
    const media = remoteConfig.media()
    if (!media.video) {
      return Log.debug('No video enabled, not amending config')
    }

    Log.debug('Injecting additional default video params')

    media.video = Object.assign(media.video, {
      minduration: 1,
      maxduration: 30,
      protocols: [1, 2, 3, 4, 5, 7],
      apis: [1, 2],
      api: [1, 2],
      mimes: ['video/mp4']
    })
  }
}
